module.exports = __webpack_public_path__ + "static/img/4386_phase_function_Paper_PointsHejduk_Prediction.232fa8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4386_phase_function_Paper_PointsHejduk_Prediction.png
// module id = os1b
// module chunks = 0